import axios from "@/api/axios";
import store from "@/store";
import _ from "lodash";

// 매장찾기 리스트
const get_shoplist = async (param, result) => {
  let finalData = {
    code: "",
    message: "",
    pageno: 1,
    pagesize: 10,
    shoplistcnt: 0,
    shoplist: [],
  };

  const options = {
    method: "GET",
    url: process.env.VUE_APP_API_URL + "/shop/shoplist",
    //url: 'http://localhost/test.php',
    //headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    params: {
      searchtype: param.searchtype,
      searchname: param.searchname,
      pageno: param.pageno,
    },
  };
  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    console.error("get_shoplist", err);
    result(false, err);
  }
};

// 매장상세보기
const get_shopinfo = async (shopno, result) => {
  let finalData = {
    code: "",
    message: "",
    shopinfo: [],
  };

  const options = {
    method: "GET",
    url: process.env.VUE_APP_API_URL + "/shop/shopinfo/" + shopno,
  };
  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    console.error("get_shopinfo", err);
    result(false, err);
  }
};

export default {
  get_shoplist,
  get_shopinfo,
};
